export default function SettingsPage(){
    return(<>
    <h1>settings</h1>
    </>)
}